"use client"

import { CustomNormalButton } from "@/components/Inputs/button"
import AppLogoWithLabel from "@/components/SVGs/logo/logo"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { IoAlertCircle } from "react-icons/io5"

export default function Error({ error, reset }) {
  const router = useRouter()

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center rounded-lg border border-dashed p-8 text-center">
      <Link underline="none" href="/">
        <AppLogoWithLabel />
      </Link>
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
        <IoAlertCircle className="h-10 w-10 text-red-500" />
      </div>
      <h2 className="mt-6 text-2xl font-semibold">Something went wrong!</h2>
      <p className="mt-2 max-w-md text-muted-foreground">
        We apologize for the inconvenience. The error has been logged and
        we&apos;re working on fixing it.
      </p>
      <p className="mt-4 max-w-md text-sm text-gray-500">
        If you need help, please{" "}
        <strong>contact our support team on 08142445807 or 07038809818</strong>.
      </p>
      {process.env.NODE_ENV === "development" && (
        <div className="mt-4 max-w-md overflow-auto rounded-md bg-slate-950 p-4 text-left text-sm text-slate-50">
          <p>{error?.message}</p>
          {error?.digest && (
            <p className="mt-2 text-xs text-slate-400">{error?.digest || ""}</p>
          )}
        </div>
      )}

      <div className="w-full mt-12 py-12 flex justify-center items-center gap-2">
        <CustomNormalButton
          sx={{ width: 150 }}
          onClick={() => reset()}
          text="Try again"
        />
        <CustomNormalButton
          sx={{ width: 150 }}
          onClick={() => router.back()}
          text="Go back"
        />
      </div>
    </div>
  )
}
